import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

//Import Icons
import FeatherIcon from "feather-icons-react";

// Redux Store
import { showRightSidebarAction } from "../../store/actions";

//CheckIn
import CheckIn from "../Common/CheckIn/CheckIn";

//import component
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown";
import LightDark from "../CommonForBoth/Menus/LightDark";

// Reactstrap
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap";

//import images
import logoSvg from "../../assets/images/logo-sm.svg";
import github from "../../assets/images/brands/github.png";
import bitbucket from "../../assets/images/brands/bitbucket.png";
import dribbble from "../../assets/images/brands/dribbble.png";
import dropbox from "../../assets/images/brands/dropbox.png";
import mail_chimp from "../../assets/images/brands/mail_chimp.png";
import slack from "../../assets/images/brands/slack.png";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
// import logoImage from "../../assets/images/logo/mount-logo-blue.png";
import logoImage from "../../assets/images/logo/mount-logo.png";
import logoMiniImage from "../../assets/images/logo/mount-min-logo-blue.png";

import { attendanceApplicableUsers } from "src/models/pages/attendanceModel";
import { hasAdminOrEmployeeRoleHandler, hasCustomerRoleHandler, hasDealerRoleHandler, hasFranchiseRoleHandler, hasFranchiseSubuserRoleHandler, hasManufacturerRoleHandler, onlyAdminRoleHandler } from "src/helpers/common_helpers";
import IncentivePoints from "src/pages/IncentivePoint/IncentivePoints";
import TicketCount from "src/pages/ticketCount/TicketCount";
import ManufacturerPrefixReport from "../HorizontalLayout/ManufacturerPrefixReport";

const Header = (props: any) => {
  const [role, setRole] = useState<string>("");
  const dispatch = useDispatch();

  useEffect(() => {
    const getAuthUser = localStorage.getItem("role");
    if (getAuthUser) {
      const obj = JSON.parse(getAuthUser);
      setRole(obj);
    }
  }, [])

  const nonauthData = createSelector(
    (state: any) => state.Layout,
    (layout) => ({
      layoutMode: layout.layoutMode,
      showRightSidebar: layout.showRightSidebar,
    })
  );
  // Inside your component
  const { layoutMode, showRightSidebar } = useSelector(nonauthData);

  const [search, setsearch] = useState<boolean>(false);
  const [socialDrp, setsocialDrp] = useState<boolean>(false);
  const [isClick, setClick] = useState<boolean>(true);

  /*** Sidebar menu icon and default menu set */
  function tToggle() {
    var body = document.body;
    var isSidebarEnabled = !body.classList.contains("sidebar-enable");
    setClick(!isClick);
    if (isSidebarEnabled) {
      body.classList.add("sidebar-enable");
      document.body.setAttribute("data-sidebar-size", "lg");
    } else {
      body.classList.remove("sidebar-enable");
      document.body.setAttribute("data-sidebar-size", "sm");
    }
  }


  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex align-items-center">
            <div className="navbar-brand-box navbar-brand" >
              <Link to="#" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logoMiniImage} alt="" className="logo-mini-width" />
                </span>
                <span className="logo-lg">
                  <img src={logoImage} alt="" className="logo-width" />{" "}
                  {/* <span className="logo-txt">Minia</span> */}
                </span>
              </Link>

              <Link to="#" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logoMiniImage} alt="" className="logo-mini-width" />
                </span>
                <span className="logo-lg">
                  <img src={logoImage} alt="" className="logo-width" />{" "}
                  {/* <span className="logo-txt">Minia</span> */}
                </span>
              </Link>
            </div>

            <button
              onClick={() => {
                tToggle();
              }}
              type="button"
              className="btn btn-sm font-size-16 header-item"
              id="vertical-menu-btn" style={{ padding: "0px", height: "100%", marginLeft: "15px" }}>
              <i className="fa fa-fw fa-bars"></i>
            </button>

            {false && (
              <form className="app-search d-none d-lg-block">
                <div className="position-relative">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search..."
                  />
                  <button className="btn btn-primary" type="button">
                    <i className="bx bx-search-alt align-middle"></i>
                  </button>
                </div>
              </form>
            )}
          </div>
          <div className="d-flex align-items-center">
            {false && (
              <div className="dropdown d-inline-block d-lg-none ms-2">
                <button
                  onClick={() => {
                    setsearch(!search);
                  }}
                  type="button"
                  className="btn header-item noti-icon " id="page-header-search-dropdown" >
                  <FeatherIcon icon="search" className="icon-lg" />
                </button>
                <div
                  className={
                    search
                      ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                      : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                  }
                  aria-labelledby="page-header-search-dropdown"
                >
                  <form className="p-3">
                    <div className="form-group m-0">
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search ..."
                          aria-label="Recipient's username"
                        />
                        <div className="input-group-append">
                          <button className="btn btn-primary" type="submit">
                            <i className="mdi mdi-magnify" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            )}

            {false && <LanguageDropdown />}

            {/* light / dark mode */}
            {false && (
              <LightDark
                layoutMode={layoutMode}
                onChangeLayoutMode={props.onChangeLayoutMode}
              />
            )}

            {false && (
              <Dropdown
                className="d-none d-lg-inline-block ms-1"
                isOpen={socialDrp}
                toggle={() => {
                  setsocialDrp(!socialDrp);
                }}
              >
                <DropdownToggle
                  className="btn header-item noti-icon "
                  tag="button"
                >
                  <FeatherIcon icon="grid" className="icon-lg" />
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-lg dropdown-menu-end">
                  <div className="p-2">
                    <Row className="g-0">
                      <Col>
                        <Link className="dropdown-icon-item" to="#">
                          <img src={github} alt="Github" />
                          <span>GitHub</span>
                        </Link>
                      </Col>
                      <Col>
                        <Link className="dropdown-icon-item" to="#">
                          <img src={bitbucket} alt="bitbucket" />
                          <span>Bitbucket</span>
                        </Link>
                      </Col>
                      <Col>
                        <Link className="dropdown-icon-item" to="#">
                          <img src={dribbble} alt="dribbble" />
                          <span>Dribbble</span>
                        </Link>
                      </Col>
                    </Row>

                    <Row className="g-0">
                      <Col>
                        <Link className="dropdown-icon-item" to="#">
                          <img src={dropbox} alt="dropbox" />
                          <span>Dropbox</span>
                        </Link>
                      </Col>
                      <Col>
                        <Link className="dropdown-icon-item" to="#">
                          <img src={mail_chimp} alt="mail_chimp" />
                          <span>Mail Chimp</span>
                        </Link>
                      </Col>
                      <Col>
                        <Link className="dropdown-icon-item" to="#">
                          <img src={slack} alt="slack" />
                          <span>Slack</span>
                        </Link>
                      </Col>
                    </Row>
                  </div>
                </DropdownMenu>
              </Dropdown>
            )}
            {
              ((hasAdminOrEmployeeRoleHandler() || hasFranchiseRoleHandler() || hasDealerRoleHandler() || hasCustomerRoleHandler() || hasManufacturerRoleHandler())) &&
              <TicketCount />
            }
            {
              ((hasAdminOrEmployeeRoleHandler() || hasFranchiseRoleHandler() || hasFranchiseSubuserRoleHandler()) && !onlyAdminRoleHandler()) &&
              <IncentivePoints />
            }
            {
              hasManufacturerRoleHandler() &&
              <ManufacturerPrefixReport />
            }
            {attendanceApplicableUsers.map((eachTitle: any) => {
              return role.includes(eachTitle.value) ?
                <CheckIn key={eachTitle.value} /> : null;
            })}
            {hasAdminOrEmployeeRoleHandler() &&
              <NotificationDropdown />}
            {
              true && (
                <div
                  onClick={() => {
                    dispatch(showRightSidebarAction(!showRightSidebar));
                  }}
                  className="dropdown d-inline-block"
                >
                  <button
                    type="button"
                    className="btn header-item noti-icon right-bar-toggle" style={{ padding: "0px", height: "100%", marginRight: "15px" }}>
                    <FeatherIcon icon="arrow-left-circle" className="icon-lg" />
                  </button>
                </div>
              )
            }
            <ProfileMenu role={role} />
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default Header;
